(() => {
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  const rgb = h => { h = (h || '#000').replace('#', '').trim(); if (h.length === 3) h = h.replace(/./g, '$&$&'); const n = parseInt(h, 16) || 0; return [n >> 16 & 255, n >> 8 & 255, n & 255]; };
  const light = h => { const [r, g, b] = rgb(h); return (r * .299 + g * .587 + b * .114) / 255 > .5; };
  const IRI = ['#3ff0cc', '#3fd8f4', '#56c4ff', '#3ff0dc', '#7cc0ff', '#46f2b8', '#9aa8ff', '#3ff0cc'].map(rgb);
  const iri = t => {
    t = ((t % 1) + 1) % 1;
    const x = t * (IRI.length - 1), i = Math.floor(x), f = x - i, a = IRI[i], b = IRI[i + 1];
    return [0, 1, 2].map(k => Math.round(a[k] + (b[k] - a[k]) * f));
  };
  const fontsReady = () => document.fonts ? Promise.all(['italic 400 80px PTSSerif', '600 40px PTSGeist'].map(f => document.fonts.load(f).catch(() => {}))).then(() => document.fonts.ready) : Promise.resolve();

  const PAL = {
    bride: { l: { rose: '#c2557e', ink: '#24335a', pearl: '#eee4d4', edge: '#bfae93' }, d: { rose: '#f293b7', ink: '#f4ede2', pearl: '#f4ecdf', edge: '#cbbda6' } },
    boutique: { l: { ring: '#557a64', gold: '#b2833a', ink: '#2c3b33' }, d: { ring: '#a6c9b3', gold: '#e5bf72', ink: '#eef3ee' } },
    baby: { l: { blue: '#5b8cd0', sage: '#6c9a81', ink: '#2c3a5a', heart: '#ec8aad', gold: '#d3a74e' }, d: { blue: '#9fc4f4', sage: '#a9d2bb', ink: '#f3ece0', heart: '#f6a3c2', gold: '#ecc979' } }
  };

  const spaced = (ctx, text, x, y, sp) => {
    const chars = [...text], widths = chars.map(c => ctx.measureText(c).width);
    let total = widths.reduce((a, b) => a + b, 0) + sp * (chars.length - 1), cx = x - total / 2;
    ctx.textAlign = 'left';
    chars.forEach((c, i) => { ctx.fillText(c, cx, y); cx += widths[i] + sp; });
    ctx.textAlign = 'center';
  };
  const pearlBead = (ctx, x, y, r, p) => {
    const g = ctx.createRadialGradient(x - r * .35, y - r * .4, r * .1, x, y, r);
    g.addColorStop(0, '#ffffff'); g.addColorStop(.45, p.pearl); g.addColorStop(1, p.edge);
    ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.fillStyle = g; ctx.fill();
  };
  const heart = (ctx, x, y, s) => {
    ctx.beginPath(); ctx.moveTo(x, y + s * .35);
    ctx.bezierCurveTo(x - s * .9, y - s * .25, x - s * .45, y - s * .95, x, y - s * .45);
    ctx.bezierCurveTo(x + s * .45, y - s * .95, x + s * .9, y - s * .25, x, y + s * .35);
    ctx.fill();
  };
  const twinkle = (ctx, x, y, s) => {
    ctx.beginPath(); ctx.moveTo(x, y - s);
    ctx.quadraticCurveTo(x, y, x + s, y); ctx.quadraticCurveTo(x, y, x, y + s);
    ctx.quadraticCurveTo(x, y, x - s, y); ctx.quadraticCurveTo(x, y, x, y - s); ctx.fill();
  };

  const DRAW = {
    bride(ctx, cx, cy, S, p) {
      ctx.textAlign = 'center'; ctx.textBaseline = 'alphabetic';
      ctx.fillStyle = p.ink; ctx.font = `600 ${S * .07}px PTSGeist, sans-serif`;
      spaced(ctx, 'TEAM', cx, cy - S * .25, S * .03);
      ctx.fillStyle = p.rose; ctx.font = `italic 400 ${S * .4}px PTSSerif, Georgia, serif`;
      ctx.fillText('Bride', cx, cy + S * .08);
      const n = 17;
      for (let i = 0; i < n; i++) {
        const t = i / (n - 1), x = cx + (t - .5) * S * .74, y = cy + S * .16 + Math.sin(t * Math.PI) * S * .1;
        pearlBead(ctx, x, y, S * (.017 + Math.sin(t * Math.PI) * .012), p);
      }
      ctx.fillStyle = p.ink; ctx.font = `600 ${S * .055}px PTSGeist, sans-serif`;
      spaced(ctx, 'BRIDAL PARTY', cx, cy + S * .4, S * .022);
    },
    boutique(ctx, cx, cy, S, p) {
      ctx.strokeStyle = p.ring; ctx.lineWidth = S * .014;
      ctx.beginPath(); ctx.arc(cx, cy, S * .43, 0, Math.PI * 2); ctx.stroke();
      ctx.lineWidth = S * .006;
      ctx.beginPath(); ctx.arc(cx, cy, S * .3, 0, Math.PI * 2); ctx.stroke();
      const ring = 'LUNA & CO  ·  BOUTIQUE  ·  LUNA & CO  ·  BOUTIQUE  ·  ';
      ctx.fillStyle = p.ring; ctx.font = `600 ${S * .05}px PTSGeist, sans-serif`; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      const chars = [...ring], step = Math.PI * 2 / chars.length;
      chars.forEach((c, i) => { const a = -Math.PI / 2 + i * step; ctx.save(); ctx.translate(cx + Math.cos(a) * S * .365, cy + Math.sin(a) * S * .365); ctx.rotate(a + Math.PI / 2); ctx.fillText(c, 0, 0); ctx.restore(); });
      ctx.textBaseline = 'alphabetic';
      ctx.fillStyle = p.gold; ctx.font = `italic 400 ${S * .25}px PTSSerif, Georgia, serif`;
      ctx.fillText('L&Co', cx, cy + S * .075);
      ctx.fillStyle = p.gold; twinkle(ctx, cx, cy - S * .17, S * .035);
      ctx.fillStyle = p.ink; ctx.font = `600 ${S * .04}px PTSGeist, sans-serif`;
      spaced(ctx, 'EST', cx, cy + S * .19, S * .02);
    },
    baby(ctx, cx, cy, S, p) {
      ctx.textAlign = 'center'; ctx.textBaseline = 'alphabetic';
      ctx.fillStyle = p.sage; ctx.font = `italic 400 ${S * .2}px PTSSerif, Georgia, serif`;
      ctx.fillText('Oh', cx - S * .2, cy - S * .12);
      ctx.fillStyle = p.blue; ctx.font = `italic 400 ${S * .4}px PTSSerif, Georgia, serif`;
      ctx.fillText('baby', cx, cy + S * .14);
      ctx.fillStyle = p.heart; heart(ctx, cx + S * .3, cy - S * .2, S * .1);
      ctx.fillStyle = p.gold;
      twinkle(ctx, cx + S * .05, cy - S * .26, S * .03); twinkle(ctx, cx - S * .36, cy + S * .02, S * .022); twinkle(ctx, cx + S * .4, cy + S * .05, S * .025);
      ctx.fillStyle = p.ink; ctx.font = `600 ${S * .065}px PTSGeist, sans-serif`;
      spaced(ctx, 'SHOWER', cx, cy + S * .33, S * .04);
    }
  };

  const makeGrain = () => {
    const c = document.createElement('canvas'); c.width = c.height = 256;
    const x = c.getContext('2d');
    x.fillStyle = 'rgba(0,0,0,.5)'; x.fillRect(0, 0, 256, 256);
    for (let i = 0; i < 160; i++) {
      const px = Math.random() * 256, py = Math.random() * 256, r = 10 + Math.random() * 34;
      for (const [ox, oy] of [[0, 0], [256, 0], [-256, 0], [0, 256], [0, -256]]) {
        const g = x.createRadialGradient(px + ox, py + oy, 0, px + ox, py + oy, r);
        g.addColorStop(0, 'rgba(0,0,0,.22)'); g.addColorStop(1, 'rgba(0,0,0,0)');
        x.fillStyle = g; x.fillRect(px + ox - r, py + oy - r, r * 2, r * 2);
      }
    }
    return c;
  };

  const initSim = stage => {
    const frame = stage.querySelector('[data-ptp-frame]'), card = frame.querySelector('.ptp-sim__card'), cv = card.querySelector('canvas');
    const ctx = cv.getContext('2d');
    const range = stage.querySelector('[data-ptp-angle]'), degEl = stage.querySelector('[data-ptp-deg]'), readEl = stage.querySelector('[data-ptp-read]');
    const hint = stage.querySelector('[data-ptp-hint]'), badge = stage.querySelector('[data-ptp-badge]'), tiltBtn = stage.querySelector('[data-ptp-tilt]');
    const modes = [...stage.querySelectorAll('[data-ptp-mode]')], designsB = [...stage.querySelectorAll('[data-ptp-design]')], shirtsB = [...stage.querySelectorAll('[data-ptp-shirt]')];
    const art = document.createElement('canvas'), sheen = document.createElement('canvas'), grain = makeGrain();
    const actx = art.getContext('2d'), sctx = sheen.getContext('2d');
    if (!fine && hint) hint.textContent = hint.dataset.touch;
    let design = stage.dataset.design, shirt = stage.dataset.shirt, mode = 'pearl';
    let ax = still ? 26 : 0, ay = still ? -6 : 0, tx = ax, ty = ay;
    let user = still, visible = false, raf = 0, t0 = performance.now(), W = 0, H = 0, dirty = true, lastRead = '';

    const size = () => {
      const r = cv.getBoundingClientRect(), dpr = Math.min(window.devicePixelRatio || 1, 2);
      const w = Math.min(1100, Math.round(r.width * dpr)), h = Math.min(1100, Math.round(r.height * dpr));
      if (!w || !h) return;
      if (w === W && h === H) return;
      W = cv.width = art.width = sheen.width = w; H = cv.height = art.height = sheen.height = h;
      paintArt();
    };
    const paintArt = () => {
      if (!W) return;
      actx.clearRect(0, 0, W, H);
      const S = Math.min(W, H) * .8, p = PAL[design] || PAL.bride;
      (DRAW[design] || DRAW.bride)(actx, W / 2, H / 2, S, light(shirt) ? p.l : p.d);
      dirty = true;
    };
    const render = () => {
      if (!W) return;
      ctx.clearRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = 1;
      ctx.drawImage(art, 0, 0);
      if (mode !== 'pearl') return;
      const m = Math.min(1, Math.hypot(ax, ay * .9) / 34), k = .16 + .84 * m * m * (3 - 2 * m);
      const ph = ax / 40 * .55 + ay / 25 * .25;
      const d = Math.hypot(W, H), ang = -.62 + ay / 25 * .35, ux = Math.cos(ang), uy = Math.sin(ang);
      const g = sctx.createLinearGradient(W / 2 - ux * d / 2, H / 2 - uy * d / 2, W / 2 + ux * d / 2, H / 2 + uy * d / 2);
      for (let i = 0; i <= 12; i++) {
        const pos = i / 12, c = iri(pos * 1.25 + ph * 1.4), band = Math.exp(-Math.pow((pos - .5 - ph * .9) / .3, 2));
        g.addColorStop(pos, `rgba(${c[0]},${c[1]},${c[2]},${(.35 + .65 * band).toFixed(3)})`);
      }
      sctx.globalCompositeOperation = 'source-over'; sctx.globalAlpha = 1;
      sctx.clearRect(0, 0, W, H);
      sctx.fillStyle = g; sctx.fillRect(0, 0, W, H);
      const c0 = .5 + ph * 1.05, hg = sctx.createLinearGradient(W / 2 - ux * d / 2, H / 2 - uy * d / 2, W / 2 + ux * d / 2, H / 2 + uy * d / 2);
      [[c0 - .16, 0], [c0 - .04, .55], [c0, .85], [c0 + .04, .55], [c0 + .16, 0]].forEach(([p, a]) => hg.addColorStop(clamp(p, 0, 1), `rgba(255,255,255,${a})`));
      sctx.fillStyle = hg; sctx.fillRect(0, 0, W, H);
      sctx.globalCompositeOperation = 'destination-in';
      const pat = sctx.createPattern(grain, 'repeat');
      sctx.fillStyle = pat; sctx.fillRect(0, 0, W, H);
      sctx.drawImage(art, 0, 0);
      ctx.globalAlpha = k * .66;
      ctx.drawImage(sheen, 0, 0);
      ctx.globalCompositeOperation = 'screen'; ctx.globalAlpha = k * .5;
      ctx.drawImage(sheen, 0, 0);
      ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = 1;
    };
    const readout = () => {
      const m = Math.hypot(ax, ay * .9), deg = Math.round(Math.abs(ax));
      degEl.textContent = deg;
      const key = mode !== 'pearl' ? 'std' : m < 9 ? 'flat' : m < 22 ? 'mid' : 'full';
      if (key !== lastRead) { lastRead = key; readEl.textContent = stage.dataset[key]; }
      range.value = Math.round(ax);
      range.setAttribute('aria-valuetext', deg + '°');
      card.style.setProperty('--rx', (-ay).toFixed(2) + 'deg');
      card.style.setProperty('--ry', ax.toFixed(2) + 'deg');
      card.style.setProperty('--gx', (50 + ax * 1.2).toFixed(1) + '%');
    };
    const tick = now => {
      raf = 0;
      if (!visible) return;
      if (!user) { const t = (now - t0) / 1000; tx = Math.sin(t * .55) * 30; ty = Math.sin(t * .37 + 1) * 9; }
      const nx = ax + (tx - ax) * (still ? 1 : .14), ny = ay + (ty - ay) * (still ? 1 : .14);
      const moved = Math.abs(nx - ax) > .01 || Math.abs(ny - ay) > .01;
      ax = nx; ay = ny;
      if (moved || dirty) { render(); readout(); dirty = false; }
      if (!user || moved) raf = requestAnimationFrame(tick);
    };
    const kick = () => { if (!raf && visible) raf = requestAnimationFrame(tick); };
    const take = () => { user = true; if (hint) hint.classList.add('is-gone'); };
    const fromPoint = (e, both) => {
      const r = frame.getBoundingClientRect();
      tx = clamp(((e.clientX - r.left) / r.width - .5) * 2 * 40, -40, 40);
      if (both) ty = clamp(((e.clientY - r.top) / r.height - .5) * 2 * 22, -22, 22);
      take(); kick();
    };
    if (fine) {
      frame.addEventListener('pointermove', e => { if (e.pointerType === 'mouse') fromPoint(e, true); });
      frame.addEventListener('pointerleave', e => { if (e.pointerType !== 'mouse' || still) return; user = false; t0 = performance.now() - Math.asin(clamp(ax / 30, -1, 1)) / .55 * 1000; kick(); });
    }
    frame.addEventListener('pointerdown', e => { if (e.pointerType === 'mouse') return; try { frame.setPointerCapture(e.pointerId); } catch (_) {} fromPoint(e, false); });
    frame.addEventListener('pointermove', e => { if (e.pointerType !== 'mouse' && frame.hasPointerCapture(e.pointerId)) fromPoint(e, false); });
    range.addEventListener('input', () => { tx = +range.value; ty = 0; take(); if (still) { ax = tx; ay = 0; dirty = true; } kick(); });
    modes.forEach(b => b.addEventListener('click', () => {
      mode = b.dataset.ptpMode;
      modes.forEach(o => o.setAttribute('aria-pressed', o === b ? 'true' : 'false'));
      badge.textContent = b.textContent; stage.classList.toggle('is-std', mode !== 'pearl');
      dirty = true; lastRead = ''; render(); readout(); kick();
    }));
    designsB.forEach(b => b.addEventListener('click', () => {
      design = b.dataset.ptpDesign;
      designsB.forEach(o => o.setAttribute('aria-pressed', o === b ? 'true' : 'false'));
      paintArt(); render(); readout(); kick();
    }));
    shirtsB.forEach(b => b.addEventListener('click', () => {
      shirt = b.dataset.ptpShirt;
      shirtsB.forEach(o => o.setAttribute('aria-pressed', o === b ? 'true' : 'false'));
      card.style.setProperty('--shirt', shirt); card.classList.toggle('is-dark', !light(shirt));
      paintArt(); render(); readout(); kick();
    }));
    card.classList.toggle('is-dark', !light(shirt));
    const orient = e => { if (e.gamma == null) return; tx = clamp(e.gamma * 1.3, -40, 40); ty = clamp(((e.beta || 45) - 45) * .6, -22, 22); take(); kick(); };
    const listen = () => { window.addEventListener('deviceorientation', orient); tiltBtn.hidden = true; };
    if (!fine && window.DeviceOrientationEvent) {
      if (typeof DeviceOrientationEvent.requestPermission === 'function') {
        tiltBtn.hidden = false;
        tiltBtn.addEventListener('click', () => DeviceOrientationEvent.requestPermission().then(s => { if (s === 'granted') listen(); }).catch(() => {}));
      } else if (!still) listen();
    }
    new IntersectionObserver(es => es.forEach(en => { visible = en.isIntersecting && !document.hidden; if (visible) { size(); dirty = true; kick(); } }), { threshold: .05 }).observe(frame);
    document.addEventListener('visibilitychange', () => { visible = !document.hidden && frame.getBoundingClientRect().bottom > 0; if (visible) kick(); });
    new ResizeObserver(() => { const oW = W; size(); if (W !== oW) { render(); } }).observe(cv);
    fontsReady().then(() => { paintArt(); render(); readout(); });
    size(); render(); readout();
  };

  const initFan = fig => {
    const btns = [...fig.querySelectorAll('[data-ptp-view]')];
    let i = 0, timer = 0, touched = false;
    const set = v => { i = v; fig.dataset.v = v; btns.forEach((b, k) => b.setAttribute('aria-pressed', k === v ? 'true' : 'false')); };
    btns.forEach((b, k) => b.addEventListener('click', () => { touched = true; clearInterval(timer); set(k); }));
    if (still) return;
    new IntersectionObserver(es => es.forEach(en => {
      clearInterval(timer);
      if (en.isIntersecting && !touched) timer = setInterval(() => set((i + 1) % btns.length), 2200);
    }), { threshold: .3 }).observe(fig);
  };

  const initCmp = box => {
    const range = box.querySelector('[data-ptp-cmp-tilt]'), grid = box.querySelector('.ptp-cmp__grid');
    let raf = 0, touched = false;
    const set = v => { v = clamp(v, -40, 40); box.style.setProperty('--t', v.toFixed(2)); box.style.setProperty('--m', (Math.abs(v) / 40).toFixed(3)); range.value = Math.round(v); range.setAttribute('aria-valuetext', Math.round(Math.abs(v)) + '°'); };
    const stop = () => { touched = true; cancelAnimationFrame(raf); };
    range.addEventListener('input', () => { stop(); set(+range.value); });
    if (fine) grid.addEventListener('pointermove', e => { if (e.pointerType !== 'mouse') return; stop(); const r = grid.getBoundingClientRect(); set(((e.clientX - r.left) / r.width - .5) * 80); });
    if (still) { set(24); return; }
    const sweep = () => {
      if (touched) return;
      const keys = [0, 32, -28, 18], dur = 3600, t0 = performance.now();
      const ease = t => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      const step = now => {
        if (touched) return;
        const t = Math.min(1, (now - t0) / dur), seg = Math.min(2, Math.floor(t * 3)), lt = ease(t * 3 - seg);
        set(keys[seg] + (keys[seg + 1] - keys[seg]) * lt);
        if (t < 1) raf = requestAnimationFrame(step);
      };
      raf = requestAnimationFrame(step);
    };
    const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { io.disconnect(); setTimeout(sweep, 500); } }), { threshold: .35 });
    io.observe(box);
  };

  const initPlace = box => {
    const spots = [...box.querySelectorAll('[data-ptp-spot]')], verdict = box.querySelector('[data-ptp-place-verdict]'), text = box.querySelector('[data-ptp-place-text]');
    const titles = [...verdict.querySelectorAll('[data-for]')];
    const pick = (b, focus) => {
      spots.forEach(o => { const on = o === b; o.setAttribute('aria-checked', on ? 'true' : 'false'); o.tabIndex = on ? 0 : -1; });
      box.querySelectorAll('[data-ptp-zone-for]').forEach(z => { z.hidden = z.dataset.ptpZoneFor !== b.dataset.ptpSpot; });
      verdict.dataset.kind = b.dataset.kind;
      titles.forEach(t => { t.hidden = t.dataset.for !== b.dataset.kind; });
      text.textContent = b.dataset.text;
      if (focus) b.focus();
    };
    spots.forEach((b, i) => {
      b.addEventListener('click', () => pick(b));
      b.addEventListener('keydown', e => {
        const d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (!d) return;
        e.preventDefault(); pick(spots[(i + d + spots.length) % spots.length], true);
      });
    });
    if (spots[0]) pick(spots[0]);
  };

  const initPeel = box => {
    const btn = box.querySelector('[data-ptp-peel-again]');
    let timers = [];
    const play = () => {
      timers.forEach(clearTimeout); timers = [];
      box.classList.remove('is-cool', 'is-peel', 'is-done');
      if (still) { box.classList.add('is-cool', 'is-peel', 'is-done'); return; }
      void box.offsetWidth;
      box.classList.add('is-hot');
      timers.push(setTimeout(() => box.classList.add('is-cool'), 900));
      timers.push(setTimeout(() => box.classList.add('is-peel'), 3500));
      timers.push(setTimeout(() => box.classList.add('is-done'), 4700));
    };
    btn.addEventListener('click', play);
    const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { io.disconnect(); play(); } }), { threshold: .45 });
    io.observe(box);
  };

  const initSize = box => {
    const chips = [...box.querySelectorAll('.ptp-size__chip')], zone = box.querySelector('[data-ptp-zone]');
    const lab = box.querySelector('[data-ptp-zone-lab]'), rl = box.querySelector('[data-ptp-size-label]'), rp = box.querySelector('[data-ptp-size-place]'), rf = box.querySelector('[data-ptp-size-fit]');
    if (!chips.length || !zone) return;
    const pick = c => {
      const n = (c.dataset.size.match(/[\d.]+/g) || []).map(Number);
      if (n.length < 2) return;
      const [w, h] = n, pocket = w <= 4 && h <= 4;
      const cx = pocket ? 4.6 : 0, top = pocket ? 4.2 : 3.6;
      zone.style.left = ((cx - w / 2 + 17) / 34 * 100) + '%';
      zone.style.top = ((top + 1.5) / 31 * 100) + '%';
      zone.style.width = (w / 34 * 100) + '%';
      zone.style.height = (h / 31 * 100) + '%';
      zone.hidden = false;
      const name = `${w} × ${h} in`;
      lab.textContent = name; rl.textContent = name;
      rp.textContent = pocket ? box.dataset.pocket : box.dataset.center;
      rf.textContent = c.dataset.fit;
      chips.forEach(o => o.setAttribute('aria-pressed', o === c ? 'true' : 'false'));
    };
    chips.forEach(c => c.addEventListener('click', () => pick(c)));
    const want = (box.dataset.default || '').replace(/\s/g, '');
    pick(chips.find(c => c.dataset.size.replace(/\s/g, '') === want) || chips[chips.length - 1]);
  };

  const initClose = card => {
    const set = x => card.style.setProperty('--sx', x.toFixed(1) + '%');
    if (fine) card.addEventListener('pointermove', e => { const r = card.getBoundingClientRect(); set((e.clientX - r.left) / r.width * 100); });
  };

  const init = root => {
    if (root.dataset.ptpReady) return;
    root.dataset.ptpReady = '1';
    root.querySelectorAll('[data-ptp-sim]').forEach(initSim);
    root.querySelectorAll('[data-ptp-fan]').forEach(initFan);
    root.querySelectorAll('[data-ptp-cmp]').forEach(initCmp);
    root.querySelectorAll('[data-ptp-place]').forEach(initPlace);
    root.querySelectorAll('[data-ptp-peel]').forEach(initPeel);
    root.querySelectorAll('[data-ptp-size]').forEach(initSize);
    root.querySelectorAll('[data-ptp-close]').forEach(initClose);
    const live = new IntersectionObserver(es => es.forEach(en => en.target.classList.toggle('is-live', en.isIntersecting)), { rootMargin: '0px 0px -8% 0px' });
    root.querySelectorAll('[data-ptp-live]').forEach(el => live.observe(el));
  };
  const boot = () => document.querySelectorAll('[data-ptp]').forEach(init);
  boot();
  document.addEventListener('shopify:section:load', boot);
})();
